<!-- Zweck: Stellt die HTML-Struktur für statistics artikel einkauf component im Frontend bereit. -->
@if ((data|async)) {
  <table class="table">
    <thead>
      <tr>
        <th colspan="13">Einkäufe {{year}} für {{artName}}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td></td>
        @for (month of monthsNums; track month) {
          <td style="height: 200px; vertical-align: bottom !important; white-space: nowrap">
            @if ((data|async)?.[month] && (data|async)?.[month].lieferMng) {
              <div class="bar lieferMng"
                matTooltip="Liefermenge {{((supplierStats) ? '- Jacoby GM Pharma GmbH ' : '')}}{{months[month]}} - {{((data|async)?.[month] ? (data|async)?.[month].lieferMng : 0)}}"
                [style.height]="(factor * ((data|async)?.[month] ? (data|async)?.[month].lieferMng : 0))+'%'"
              ></div>
            }
            @if ((data|async)?.[month] && (data|async)?.[month].rechMng) {
              <div class="bar rechMng"
                matTooltip="Rechnungsmenge {{((supplierStats) ? '- Jacoby GM Pharma GmbH ' : '')}}{{months[month]}} - {{((data|async)?.[month] ? (data|async)?.[month].rechMng : 0)}}"
                [style.height]="(factor * ((data|async)?.[month] ? (data|async)?.[month].rechMng : 0))+'%'"
              ></div>
            }
            @for (sstat of supplierStats; track sstat; let idx1 = $index) {
              @for (smonth of sstat.months; track smonth) {
                @if (smonth.monat == month) {
                  @if (smonth.menge && smonth.menge > 0) {
                    <div class="bar bar{{idx1+1}}"
                      matTooltip="Bestellmenge {{((supplierStats) ? '- '+sstat.supplierName+' ' : '')}}{{months[smonth.monat]}} - {{smonth.menge}}"
                      [style.height]="(factor * smonth.menge ? smonth.menge : 0)+'%'"
                    ></div>
                  }
                  @if (smonth.liefermenge && smonth.liefermenge > 0) {
                    <div class="bar bar{{idx1+1}}-2"
                      matTooltip="Liefermenge {{((supplierStats) ? '- '+sstat.supplierName+' ' : '')}}{{months[smonth.monat]}} - {{smonth.liefermenge}}"
                      [style.height]="(factor * smonth.liefermenge ? smonth.liefermenge : 0)+'%'"
                    ></div>
                  }
                }
              }
            }
          </td>
        }
      </tr>
      @if (supplierStats) {
        <tr>
          <td colspan="13"><strong>Jacoby GM Pharma GmbH</strong></td>
        </tr>
      }
      <tr>
        <td style="cursor: help" matTooltip="Rechnungsmenge">RM</td>
        @for (month of monthsNums; track month) {
          <td>
            @if ((data|async)?.[month]) {
              <span>
                {{(data|async)?.[month].rechMng}}
              </span>
            }
            @if (!(data|async)?.[month]) {
              <span>
                0
              </span>
            }
          </td>
        }
      </tr>
      <tr>
        <td style="cursor: help" matTooltip="Liefermenge">LM</td>
        @for (month of monthsNums; track month) {
          <td>
            @if ((data|async)?.[month]) {
              <span>
                {{(data|async)?.[month].lieferMng}}
              </span>
            }
            @if (!(data|async)?.[month]) {
              <span>
                0
              </span>
            }
          </td>
        }
      </tr>
      @for (sstat of supplierStats; track sstat) {
        <tr>
          <td colspan="13"><strong>{{ sstat.supplierName }}</strong></td>
        </tr>
        <tr>
          <td style="cursor: help" matTooltip="Bestellmenge">BM</td>
          @for (month of sstat.months; track month) {
            <td>
              {{month.menge}}
            </td>
          }
        </tr>
        <tr>
          <td style="cursor: help" matTooltip="Liefermenge">LM</td>
          @for (month of sstat.months; track month) {
            <td>
              {{month.liefermenge}}
            </td>
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <th>Monat</th>
        @for (month of monthsNums; track month) {
          <th>
            {{months[month]}}
          </th>
        }
      </tr>
    </tfoot>
  </table>
}
